export default [{
    text: 'любой',
    value: 'any',
}, {
    text: 'семья',
    value: 'family',
}, {
    text: 'женщина',
    value: 'female',
}, {
    text: 'мужчина',
    value: 'male',
}];
